import { routeUrl } from "@/app/routes";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { PendingSurveyItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { formatDateOnly } from "@/shared/lib/format-date-only";

function surveyMeta(survey: PendingSurveyItem): string {
  const due = formatDateOnly(survey.dueAt ?? null);
  const progress =
    survey.answeredCount !== undefined && survey.questionCount !== undefined
      ? `${survey.answeredCount} of ${survey.questionCount} answered`
      : null;
  return [due ? `Due ${due}` : null, progress]
    .filter((part): part is string => part !== null)
    .join(" · ");
}

export function PendingSurveysReadCard({
  items,
  slug,
  hasMore = false,
}: {
  items: PendingSurveyItem[];
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title="Pending surveys"
      viewAllHref={routeUrl.pulse.mine(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((survey) => {
        const meta = surveyMeta(survey);
        return (
          <li key={survey.deliveryId}>
            <a
              href={routeUrl.pulseSurveys.respond(slug, survey.deliveryId)}
              className="flex items-center gap-2.5 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
            >
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 break-words">{survey.untrustedTitle}</span>
                {meta ? (
                  <span className="block truncate text-xs text-text-secondary">{meta}</span>
                ) : null}
              </span>
              <span className="shrink-0 text-xs text-primary">Respond</span>
            </a>
          </li>
        );
      })}
    </ReadCardFrame>
  );
}
